<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label">Ejecutiva:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica();ListarCotizaciones(TipoCotizacion,TiempoCotizacion)" v-model="Filtro.IdVendedor" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Vendedores" :key="ind" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica();ListarCotizaciones(TipoCotizacion,TiempoCotizacion)" v-model="Filtro.Mes" class="form-select form-control-search">
                        <option v-for="(item,ind) in Meses" :key="ind" :value="item.Value">{{item.Tag}}</option>
                    </select>
                </div>
            </template>

            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="row mt-3 justify-content-center">
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                <h6>Cotizaciones Pendientes</h6>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="card text-white bg-success h-100">
                                            <div class="card-body">
                                                <div class="card-body-icon">
                                                    <i class="fa fa-fw fa-money-bill-alt"></i>
                                                </div>
                                                <h5 class="text-white">
                                                    Mes Anterior
                                                    <br>
                                                    $ {{ MontoCotizacionesPendientesAnterior }}
                                                </h5>
                                            </div>
                                            <div @click="ListarCotizaciones('Pendientes','Anteriores')" class="card-footer clearfix small z-index-1">
                                                <span style="float:left;font-size:15px;">Total Pendiente</span>
                                                <span style="float:right; width:30px">
                                                    <div class="circNum">
                                                        <p>{{ CotizacionesPendientesAnterior }}</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-lg-12">
                                        <div class="card text-white bg-danger h-100">
                                            <div class="card-body">
                                                <div class="card-body-icon">
                                                    <i class="fa fa-fw fa-money-bill-alt"></i>
                                                </div>
                                                <h5 class="text-white">
                                                    Mes Actual
                                                    <br>
                                                    $ {{ MontoCotizacionesPendientesActual }}
                                                </h5>
                                            </div>
                                            <div @click="ListarCotizaciones('Pendientes','Actuales')" class="card-footer clearfix small z-index-1">
                                                <span style="float:left;font-size:15px;">Total Pendiente</span>
                                                <span style="float:right; width:30px">
                                                    <div class="circNum">
                                                        <p>{{ CotizacionesPendientesActual }}</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                <h6>Cotizaciones Autorizadas</h6>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="card text-white bg-success h-100">
                                            <div class="card-body">
                                                <div class="card-body-icon">
                                                    <i class="fa fa-fw fa-money-bill-alt"></i>
                                                </div>
                                                <h5 class="text-white">
                                                    Mes Anterior
                                                    <br>
                                                    $ {{ MontoCotizacionesAutorizadasAnterior }}
                                                </h5>
                                            </div>
                                            <div @click="ListarCotizaciones('Autorizadas','Anteriores')" class="card-footer clearfix small z-index-1">
                                                <span style="float:left;font-size:15px;">Total Autorizados</span>
                                                <span style="float:right; width:30px">
                                                    <div class="circNum">
                                                        <p>{{ CotizacionesAutorizadasAnterior }}</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-lg-12">
                                        <div class="card text-white bg-danger h-100">
                                            <div class="card-body">
                                                <div class="card-body-icon">
                                                    <i class="fa fa-fw fa-money-bill-alt"></i>
                                                </div>
                                                <h5 class="text-white">
                                                    Mes Actual
                                                    <br>
                                                    $ {{ MontoCotizacionesAutorizadasActual }}
                                                </h5>
                                            </div>
                                            <div @click="ListarCotizaciones('Autorizadas','Actuales')" class="card-footer clearfix small z-index-1">
                                                <span style="float:left;font-size:15px;">Total Autorizados</span>
                                                <span style="float:right; width:30px">
                                                    <div class="circNum">
                                                        <p>{{ CotizacionesAutorizadasActual }}</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
                                <h5>{{ TituloTabla }}</h5>
                                <div class="table-responsive pb-0" style="max-height:150px;overflow-y:auto;">
                                    <table class="table align-items-center mb-0">
                                        <thead>
                                            <tr>
                                                <th>Cotización</th>
                                                <th>Fecha</th>
                                                <th>Fecha Modif.</th>
                                                <th>Total Elementos</th>
                                                <th>Total Paquete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item,index) in ListaCotizaciones" :key="index">
                                                <td>{{ item.Folio }}</td>
                                                <td>{{ item.FechaBoda }}</td>
                                                <td>{{ item.FechaModif == null ? "Sin Fecha" : $getCleanDate(item.FechaModif,false) }}</td>
                                                <td>$ {{ item.TotalGlobal }}</td>
                                                <td>$ {{ item.TotalGlobalPaqt }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="card text-white bg-info h-100">
                                            <div class="card-body">
                                                <div class="card-body-icon">
                                                    <i class="fa fa-fw fa-money-bill-alt"></i>
                                                </div>
                                                <h5 class="text-white">
                                                    Acumulable
                                                    <br>
                                                    $ {{ MontoAcumulable }}
                                                </h5>
                                            </div>
                                            <div @click="ListarCotizaciones('Todos','Actuales')" class="card-footer clearfix small z-index-1">
                                                <span style="float:left;font-size:15px;">Total Autorizados</span>
                                                <span style="float:right; width:30px">
                                                    <div class="circNum">
                                                        <p>{{ Acumulable }}</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </CLoader>
            </template>
        </CList>
    </div>
</template>

<script>
const EmitEjecuta='seccionRendimientoCotizacion'
export default {
    name:'RendimientoCotizacion',
    data() {
        return {
            ConfigList:{
                Title:'Evaluación de Personal',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: true,
                ShowPaginador: false,
                ShowSearch:false,
                ShowEntradas:false,
                TypeBody: 'Form',
				TitleFirst: 'CRM',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:false
            },
            Filtro:{
                IdVendedor:'',
                Mes:(new Date().getMonth()+1).toString(),
                Anio:new Date().getFullYear(),
                // Anio:'2023',
            },
            segurity:{},
            Vendedores:[],
            Meses:[
                {Tag:"Enero",Value:"1"},
                {Tag:"Febrero",Value:"2"},
                {Tag:"Marzo",Value:"3"},
                {Tag:"Abril",Value:"4"},
                {Tag:"Mayo",Value:"5"},
                {Tag:"Junio",Value:"6"},
                {Tag:"Julio",Value:"7"},
                {Tag:"Agosto",Value:"8"},
                {Tag:"Septiembre",Value:"9"},
                {Tag:"Octubre",Value:"10"},
                {Tag:"Noviembre",Value:"11"},
                {Tag:"Diciembre",Value:"12"}
            ],
            TituloTabla:'Cotizaciones Autorizadas >> Actuales',
            TipoCotizacion:'Autorizadas',
            TiempoCotizacion:'Actuales',
            MontoCotizacionesPendientesActual:0,
            CotizacionesPendientesActual:0,
            MontoCotizacionesAutorizadasActual:0,
            CotizacionesAutorizadasActual:0,
            MontoCotizacionesPendientesAnterior:0,
            CotizacionesPendientesAnterior:0,
            MontoCotizacionesAutorizadasAnterior:0,
            CotizacionesAutorizadasAnterior:0,
            MontoAcumulable:0,
            Acumulable:0,
            ListaCotizaciones:[]
        }
    },
    methods: {
        async GetDatosGrafica(){
            this.ConfigLoad.ShowLoader=true;
            await this.$http.get('rendimientoCotizacion',{
                params:{
                    IdVendedor:this.Filtro.IdVendedor,
                    Anio:this.Filtro.Anio,
                    Mes:this.Filtro.Mes,
                }
            }).then((res)=>{
                this.MontoCotizacionesPendientesActual=res.data.data.MontoCotizacionesPendientesActual;
                this.CotizacionesPendientesActual=res.data.data.CotizacionesPendientesActual;
                this.MontoCotizacionesAutorizadasActual=res.data.data.MontoCotizacionesAutorizadasActual;
                this.CotizacionesAutorizadasActual=res.data.data.CotizacionesAutorizadasActual;
                this.MontoCotizacionesPendientesAnterior=res.data.data.MontoCotizacionesPendientesAnterior;
                this.CotizacionesPendientesAnterior=res.data.data.CotizacionesPendientesAnterior;
                this.MontoCotizacionesAutorizadasAnterior=res.data.data.MontoCotizacionesAutorizadasAnterior;
                this.CotizacionesAutorizadasAnterior=res.data.data.CotizacionesAutorizadasAnterior;
                this.MontoAcumulable=res.data.data.MontoAcumulable;
                this.Acumulable=res.data.data.Acumulable;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        ListarCotizaciones(Tipo,Tiempo){
            this.ListaCotizaciones=[];
            let Todos=Tipo=='Todos' ? true : false;
            let Anio=this.Filtro.Anio;
            let Mes=this.Filtro.Mes;
            
            this.TituloTabla=Tipo=='Todos' ? 'Cotizaciones Todas >> Autorizadas' : 'Cotizaciones '+Tipo+' >> '+Tiempo;
            this.TipoCotizacion=Tipo;
            this.TiempoCotizacion=Tiempo
            
            if (Tiempo=='Anteriores') {
                if (Mes=="1") {
                    Mes="12";
                    Anio--;
                }
                else{
                    Mes=parseInt(Mes)-1;
                }
            }
            this.$http.get('rendimientoCotizacionLista',{
                params:{
                    IdVendedor:this.Filtro.IdVendedor,
                    Anio:Anio,
                    Mes:Mes,
                    TipoCotizacion:Tipo,
                    TodasAutorizadas:Todos
                }
            }).then((res)=>{
                this.ListaCotizaciones=res.data.data;
            });
        },
        ListarFiltros(){
            this.$http.get('rendimientoCotizacionFiltros',{
            }).then((res)=>{
                this.Vendedores=res.data.data.Vendedores;
            })
        }
    },
    mounted() {
        this.ListarFiltros();
        this.GetDatosGrafica();
        this.ListarCotizaciones('Autorizadas','Actuales');
    },
}
</script>

<style>

</style>